// PRJ1417943 - Integration Accelerator - Agency helper functions - changed from direct imports to function calls to resolve circular dependencies
import { getAgencyData } from '../data/agencyData';
import { getAgencyRules } from '../validation/rules/agencies';
import { getAgencyErrors } from '../validation/errorsMap/agencies';

// helpers to fetch agency data dynamically
export function getAgencySlugByCode(code) {
  const { agencySlugMap } = getAgencyData();
  return agencySlugMap[code].slug;
}

export function getAgencyCodeBySlug(slug) {
  const { agencyData } =  getAgencyData();
  return agencyData[slug].agencyCode;
}

export function getAppSlugByCodes(agencyCode, appCode) {
  const { agencySlugMap } = getAgencyData();
  return agencySlugMap[agencyCode][appCode];
}

export function getAgencyDataByCode(code) {
  const { agencyData, agencySlugMap } = getAgencyData();
  return agencyData[agencySlugMap[code].slug];
}

export function getAppDataByCodes(agencyCode, appCode) {
  const { agencyData, agencySlugMap } = getAgencyData();
  return agencyData[agencySlugMap[agencyCode][appCode]];
}

export function getAgencyDataBySlug(slug) {
  const { agencyData } = getAgencyData();
  return agencyData[slug];
}

export function getAppDataBySlug(slug) {
  const { agencyData } = getAgencyData();
  return agencyData[slug];
}

export function getAppValidationRulesBySlugs(agencySlug, appSlug) {
  const agencyRules = getAgencyRules();
  // null-checking to prevent if agency/app rules are missing
  if (
    agencyRules &&
    agencyRules[agencySlug] &&
    agencyRules[agencySlug].APP_RULES &&
    agencyRules[agencySlug].APP_RULES[appSlug]
  ) {
    return agencyRules[agencySlug].APP_RULES[appSlug];
  }
  return undefined;
}

export function getAgencyErrorsMap() {
  return getAgencyErrors();
}
